export class ReportExplanationIconSelectors {
  static reportExplanation = 'reportExplanation';
}